import {useState} from "react";

import {CASE_MODAL_CONTENT} from "../components/CaseModalContent";

export const useCaseManagementUIState = () => {
  const [selectedCase, setSelectedCase] = useState(null);
  const [selectedOrganization, setSelectedOrganization] = useState({});
  const [selectedStatus, setSelectedStatus] = useState("processing");
  const [assigningStatus, setAssigningStatus] = useState<{id: string; name: string}>({id: "", name: ""});
  const [dialogContent, setDialogContent] = useState<CASE_MODAL_CONTENT | "">("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("success");
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");
  const [mode, setMode] = useState<string>("");

  const handleSort = (column) => {
    const newOrder = sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
    setSortColumn(column);
    setSortOrder(newOrder);
  };

  const handleOnClickReportButton = () => setDialogContent(CASE_MODAL_CONTENT.REPORT);
  const handleOnClickSurveyButton = () => setDialogContent(CASE_MODAL_CONTENT.SURVEY);
  const handleCloseDialog = () => setDialogContent("");
  const handleChangeStatus = (value) => setAssigningStatus(value);
  const handleChangeAssigningOrganization = (value) => setSelectedOrganization(value);

  const handleOnClickBrowseCase = (caseItem, selectedMode) => {
    setSelectedCase(caseItem);
    setDialogContent(CASE_MODAL_CONTENT.PROCESSING);
    setMode(selectedMode);
  };

  const handleOnClickDeleteButton = (caseItem) => {
    setSelectedCase(caseItem);
    setDialogContent(CASE_MODAL_CONTENT.CONFIRM_DELETE);
  };

  return {
    selectedCase,
    selectedOrganization,
    selectedStatus,
    assigningStatus,
    dialogContent,
    message,
    messageType,
    sortColumn,
    sortOrder,
    mode,
    setDialogContent,
    setMessage,
    setMessageType,
    setSelectedStatus,
    handleSort,
    handleOnClickReportButton,
    handleOnClickSurveyButton,
    handleCloseDialog,
    handleChangeStatus,
    handleChangeAssigningOrganization,
    handleOnClickBrowseCase,
    handleOnClickDeleteButton,
  };
};
